import styled from 'styled-components'

export const AuthWrapper = styled.div`
  background-image: url(${require('app/assets/img/bg/1.jpg')});
`

export const Img = styled.img`
  width: 100%;
`
